import { render } from "./AppHeader.vue?vue&type=template&id=b32c8826&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=b32c8826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32c8826"]])

export default __exports__